export const PROGRAM_TYPES = {
    SERIES: 'series',
    MOVIE: 'movie',
};

export const VOD = 'VOD';
